import { useRef, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import { Group } from 'three'
import { Foliage } from './Foliage'
import { Ornaments } from './Ornaments'
import { TreeStar } from './TreeStar'
import { TreeTrunk } from './TreeTrunk'
import { Polaroids } from './Polaroids'
import { useTreeStore } from '../../store/useTreeStore'

export function ChristmasTree() {
  const groupRef = useRef<Group>(null)
  const sceneGroupRef = useRef<Group>(null)
  const {
    targetState,
    progress,
    galleryProgress,
    treeRotationY,
    sceneRotationY
  } = useTreeStore()
  
  // 当前旋转角度（用于平滑过渡）
  const currentTreeRotationRef = useRef(0)
  const currentSceneRotationRef = useRef(0)
  
  // 当进入画廊模式时，立即重置旋转 ref 值
  useEffect(() => {
    if (targetState === 'GALLERY') {
      // 立即重置旋转到正面
      currentTreeRotationRef.current = 0
      currentSceneRotationRef.current = 0
      if (groupRef.current) {
        groupRef.current.rotation.y = 0
      }
      if (sceneGroupRef.current) {
        sceneGroupRef.current.rotation.y = 0
      }
    }
  }, [targetState])
  
  // 动画更新
  useFrame(() => {
    // 平滑旋转圣诞树（FORMED 模式）
    if (groupRef.current) {
      const targetRotation = treeRotationY * (Math.PI / 180)
      currentTreeRotationRef.current += (targetRotation - currentTreeRotationRef.current) * 0.1
      groupRef.current.rotation.y = currentTreeRotationRef.current
    }
    
    // 平滑旋转整个场景（CHAOS 模式）
    if (sceneGroupRef.current) {
      const targetSceneRotation = sceneRotationY * (Math.PI / 180)
      currentSceneRotationRef.current += (targetSceneRotation - currentSceneRotationRef.current) * 0.1
      sceneGroupRef.current.rotation.y = currentSceneRotationRef.current
    }
  })
  
  // 画廊模式下，粒子和装饰物保持可见，只是照片浮在上层
  // 不再隐藏整个圣诞树组
  
  return (
    <group ref={sceneGroupRef}>
      {/* 圣诞树主体 - 画廊模式下保持可见 */}
      <group ref={groupRef}>
        {/* 树干 - 画廊模式下隐藏 */}
        {galleryProgress < 0.5 && (
          <TreeTrunk progress={progress} />
        )}
        
        {/* 针叶粒子系统 - 始终可见 */}
        <Foliage progress={progress} />
        
        {/* 装饰物（铃铛等）- 始终可见 */}
        <Ornaments progress={progress} />
        
        {/* 拍立得照片 - 始终可见，画廊模式下会自动过渡到焦点布局 */}
        <Polaroids progress={progress} galleryProgress={galleryProgress} />
        
        {/* 树顶星星 - 画廊模式下隐藏 */}
        {galleryProgress < 0.5 && (
          <TreeStar progress={progress} />
        )}
      </group>
    </group>
  )
}